/**
 * Whether a contact reached the agent via a transfer (agent or queue).
 * Reads the `connect` global lazily, so this module is safe to import
 * before `amazon-connect-streams` has loaded.
 * @param method the contact's initiation method
 * @returns true for agent and queue transfers
 */
export function isTransferMethod(
  method: connect.ContactInitiationMethod | undefined
): boolean {
  return (
    method === connect.ContactInitiationMethod.TRANSFER ||
    method === connect.ContactInitiationMethod.QUEUE_TRANSFER
  )
}
